import { useEffect, useState } from 'react';
import { getApi } from 'views/services/api';
import Logo from 'ui-component/Logo.png';
import { ButtonBase } from '@mui/material';

const LogoSection = () => {
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const [logoUrl, setLogoUrl] = useState(Logo);
  // const baseUrl = process.env.REACT_APP_BASE_URL || '';
  const baseUrl = 'https://hotelcrm.samyotech.in/api/';

  const fetchHotelData = async () => {
    try {
      const response = await getApi(`api/hotel/view/${hotel?.hotelId}`);
      const imageUrl = response.data.hotelImage ? `${baseUrl}${response.data.hotelImage}` : Logo;
      setLogoUrl(imageUrl);
    } catch (error) {
      console.log('Error fetching hotel data:', error);
    }
  };

  useEffect(() => {
    fetchHotelData();
  }, [hotel?.hotelId]);

  return (
    <ButtonBase disableRipple>
      <img
        src={logoUrl}
        alt="logo"
        style={{
          width: '178px',
          height: '40px',
          objectFit: 'cover',
          overflow: 'hidden'
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = Logo;
        }}
      />
    </ButtonBase>
  );
};

export default LogoSection;
